import { LabelList } from './LabelList';

export default LabelList;
